import type { FieldValues, Path, UseFormRegister, UseFormWatch } from 'react-hook-form';

interface RadioOption {
  value: string;
  label: string;
}

interface RadioPillGroupProps<T extends FieldValues> {
  name: Path<T>;
  options: readonly RadioOption[];
  columns: 2 | 3;
  register: UseFormRegister<T>;
  watch: UseFormWatch<T>;
}

export function RadioPillGroup<T extends FieldValues>({
  name,
  options,
  columns,
  register,
  watch,
}: RadioPillGroupProps<T>) {
  const selected = watch(name) as string | undefined;
  const gridClass = columns === 3 ? 'grid-cols-3' : 'grid-cols-2';

  return (
    <div className={`grid ${gridClass} gap-2`}>
      {options.map((option) => (
        <label
          key={option.value}
          className={`cursor-pointer rounded-lg border-2 px-3 py-3 text-center text-sm ${
            selected === option.value
              ? 'border-ndd-400 bg-ndd-800'
              : 'border-ndd-700 bg-ndd-900 hover:border-ndd-500'
          }`}
        >
          <input type="radio" value={option.value} {...register(name)} className="sr-only" />
          {option.label}
        </label>
      ))}
    </div>
  );
}
